import { useState } from "react";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  text: string;
  limit: number;
  className: string;
  moreClassName: string;
}

const LessMore: React.FC<Props> = ({
  text,
  limit,
  className,
  moreClassName,
}) => {
  const t = useTranslation();
  const [more, setMore] = useState(true);
  if (!text) return null;
  if (text?.length <= limit + 30)
    return <div className={className}>{text}</div>;

  return (
    <div>
      <span className={className}>
        {more ? text?.substring(0, limit - 1) : text}
      </span>
      <span onClick={() => setMore(!more)} className={moreClassName}>
        {more ? t.see_more : t.see_less}
      </span>
    </div>
  );
};

export default LessMore;
